module.exports = __webpack_public_path__ + "static/img/bank_content02.f2d2abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank_content02.png
// module id = PpDC
// module chunks = 1